var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 52px;\n  input[type=checkbox]:checked + .s-switch-nob:before {\n    top: 2px;\n    left: 20px;\n  }\n\n  input[type=checkbox]:checked + .s-switch-nob {\n    border: 0;\n    background: ', ';\n\n  }\n\n  input[type=checkbox] {\n    height: 0;\n    width: 0;\n    visibility: hidden;\n  }\n'], ['\n  max-width: 52px;\n  input[type=checkbox]:checked + .s-switch-nob:before {\n    top: 2px;\n    left: 20px;\n  }\n\n  input[type=checkbox]:checked + .s-switch-nob {\n    border: 0;\n    background: ', ';\n\n  }\n\n  input[type=checkbox] {\n    height: 0;\n    width: 0;\n    visibility: hidden;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    cursor: pointer;\n    height: 31px;\n    width: 49px;\n    background: ', ';\n    border-radius: 15px;\n    border: 1px solid ', ';\n    box-sizing: border-box;\n    position: relative;\n\n    &:before {\n      content: \'\';\n      cursor: pointer;\n      height: 27px;\n      width: 27px;\n      border-radius: 50%;\n      background: ', ';;\n      border: 1px ', ';\n      box-sizing: border-box;\n      left: 1px;\n      top: 1px;\n      box-shadow: ', ';\n      position: absolute;\n      transition: all ', ' ', ';\n      max-width: 30px;\n    }\n'], ['\n    cursor: pointer;\n    height: 31px;\n    width: 49px;\n    background: ', ';\n    border-radius: 15px;\n    border: 1px solid ', ';\n    box-sizing: border-box;\n    position: relative;\n\n    &:before {\n      content: \'\';\n      cursor: pointer;\n      height: 27px;\n      width: 27px;\n      border-radius: 50%;\n      background: ', ';;\n      border: 1px ', ';\n      box-sizing: border-box;\n      left: 1px;\n      top: 1px;\n      box-shadow: ', ';\n      position: absolute;\n      transition: all ', ' ', ';\n      max-width: 30px;\n    }\n']);

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var StyledSwitchContainer = styled.div(_templateObject, function (props) {
  return props.theme.colours.primary.base;
});
var Nob = styled.div(_templateObject2, function (props) {
  return props.theme.colours.neutral.light;
}, function (props) {
  return props.theme.colours.neutral.light;
}, function (props) {
  return props.theme.colours.neutral.lightest;
}, function (props) {
  return props.theme.colours.neutral.lighter;
}, function (props) {
  return props.theme.boxShadow["100"];
}, function (props) {
  return props.theme.animation.speed.base;
}, function (props) {
  return props.theme.animation.ease.base;
});

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.render = function render() {
    var _props = this.props,
        switchName = _props.switchName,
        isChecked = _props.isChecked,
        rest = _objectWithoutProperties(_props, ['switchName', 'isChecked']);

    return React.createElement(StyledSwitchContainer, null, React.createElement('label', {
      htmlFor: switchName
    }, React.createElement('input', _extends({
      type: 'checkbox',
      defaultChecked: isChecked
    }, rest, {
      role: 'switch',
      id: switchName
    })), React.createElement(Nob, {
      className: 's-switch-nob'
    })));
  };

  return Switch;
}(React.Component);

export { Switch as default };